export enum FeeStatus {
  FreeDays = 'freeDays',
  Free = 'free',
  NeedsToFree = 'needsToFree',
  Default = 'default',
  Hide = 'hide',
}
